import {asyncType} from 'redux/helpers';

export const keysKey = 'keys';

export default {
   CREATE_SSH_KEY_PAIR: asyncType(`${keysKey}/CREATE_SSH_KEY_PAIR`),
   START_POLL_SSH_KEY_PAIR_STATUS: `${keysKey}/START_POLL_SSH_KEY_PAIR_STATUS`,
   STOP_POLL_SSH_KEY_PAIR_STATUS: `${keysKey}/STOP_POLL_SSH_KEY_PAIR_STATUS`,

   IMPORT_PGP_KEY_PAIR: asyncType(`${keysKey}/IMPORT_PGP_KEY_PAIR`),
   IMPORT_PGP_PUBLIC: asyncType(`${keysKey}/IMPORT_PGP_PUBLIC`),
   IMPORT_PGP_READ: asyncType(`${keysKey}/IMPORT_PGP_READ`),

   CREATE_OPEN_PGP_KEY_PAIR: asyncType(`${keysKey}/CREATE_OPEN_PGP_KEY_PAIR`),
   GET_UNUSED_PGP_KEYS: asyncType(`${keysKey}/GET_UNUSED_PGP_KEYS`),
   GET_USED_PGP_KEYS: asyncType(`${keysKey}/GET_USED_PGP_KEYS`),
   MOVE_KEYS: asyncType(`${keysKey}/MOVE_KEYS`),
   RELEASE_KEY: `${keysKey}/RELEASE_KEY`,
   SUSPEND_KEY: `${keysKey}/SUSPEND_KEY`,
   EXPORT: asyncType(`${keysKey}/EXPORT`),
   GET_DEFAULT_KEY_STORE: asyncType(`${keysKey}/GET_DEFAULT_KEY_STORE`),
   UPDATE_PGP_KEY: asyncType(`${keysKey}/UPDATE_PGP_KEY`),
   UPDATE_SSL_CERT: asyncType(`${keysKey}/UPDATE_SSL_CERT`),

   REPLACE_KEY: asyncType(`${keysKey}/REPLACE_KEY`),
   IMPORT_REMOTE_KEY: asyncType(`${keysKey}/IMPORT_REMOTE_KEY`),
   UPLOAD_REMOTE_KEY: asyncType(`${keysKey}/UPLOAD_REMOTE_KEY`),
};
